import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ArrowLeftIcon, ArrowRightIcon } from '@mui/x-date-pickers';
import { useGetScreenSize } from '@utils/useGetScreenSize';

type MobileColumnControlProps = {
  columnsForScreenSize: any[];
  headerName: string;
  columnVisibilityModel: { [key: string]: boolean };
  onSetVisibleMobileColumnIndex: React.Dispatch<React.SetStateAction<number>>;
  lockedColumn: string;
};

export const MobileColumnControl: React.FC<MobileColumnControlProps> = ({
  columnsForScreenSize,
  columnVisibilityModel,
  onSetVisibleMobileColumnIndex,
  headerName,
  lockedColumn,
}) => {
  const { isMobileScreen } = useGetScreenSize();

  const lockedIndex = columnsForScreenSize.findIndex((col) => col.field === lockedColumn);

  return (
    <Box
      id='mobile-column-control'
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      {isMobileScreen && (
        <IconButton
          size='small'
          sx={{ color: 'gray !important' }}
          onClick={() => {
            onSetVisibleMobileColumnIndex((cur) => {
              let nextIndex = cur - 1;

              if (nextIndex < 0) {
                nextIndex = columnsForScreenSize.length - 1;
              }

              while (
                nextIndex === lockedIndex ||
                (columnVisibilityModel && !columnVisibilityModel[columnsForScreenSize[nextIndex].field])
              ) {
                nextIndex = nextIndex - 1;

                if (nextIndex < 0) {
                  nextIndex = columnsForScreenSize.length - 1;
                }
              }

              if (nextIndex <= 0) {
                return columnsForScreenSize.length - 1 === lockedIndex
                  ? columnsForScreenSize.length - 2
                  : columnsForScreenSize.length - 1;
              } else {
                return nextIndex;
              }
            });
          }}
        >
          <ArrowLeftIcon />
        </IconButton>
      )}
      <Typography variant='tableHeader' color='text.subdued' fontWeight='bold' sx={{}}>
        {headerName}
      </Typography>

      {isMobileScreen && (
        <IconButton
          size='small'
          sx={{ color: 'gray !important' }}
          onClick={() => {
            onSetVisibleMobileColumnIndex((cur) => {
              let nextIndex = cur + 1;

              if (nextIndex >= columnsForScreenSize.length) {
                nextIndex = 1;
              }

              while (
                nextIndex === lockedIndex ||
                (columnVisibilityModel && !columnVisibilityModel[columnsForScreenSize[nextIndex].field])
              ) {
                nextIndex = nextIndex + 1;

                if (nextIndex >= columnsForScreenSize.length - 1) {
                  nextIndex = lockedIndex === 0 ? 1 : 0;
                }
              }

              if (nextIndex >= columnsForScreenSize.length) {
                return lockedIndex === 0 ? 1 : 0;
              } else {
                return nextIndex;
              }
            });
          }}
        >
          <ArrowRightIcon />
        </IconButton>
      )}
    </Box>
  );
};
